<template>
  <div class="filelist">
    <FileSee ref='FileSee' :info='info'></FileSee>
    <drag-modal :visible="visible" @cancel="visible = false" title='修改附件名称' width='460px'>
      <div class="selectbox">
        <div class="lf">
          <div class="input">
            <label>附件名称：</label>
            <a-input placeholder='请输入附件新名称' style="width:190px;" v-model='file.title'> </a-input>
          </div>
        </div>
        <div class="btns">
          <a-button type='primary' icon='check-circle' @click='setName'>确定修改</a-button>
        </div>
      </div>
    </drag-modal>
    <drag-modal :visible="$store.state.dislog.filelist" @cancel="close" :title='type == 0 ? "附件汇总" : "沟通附件汇总"'
      width='840px'>
      <div class="selectbox">
        <div class="lf">
          <div class="input">
            <label>文件名称：</label>
            <a-input placeholder='请输入文件名称' style="width:190px;" v-model='form.title'> </a-input>
          </div>
          <div class="input">
            <label>案件筛选：</label>
            <a-select style="width: 114px" placeholder="请选择" v-model='form.cause_id'>
              <a-select-option :key='null'>请选择</a-select-option>
              <a-select-option v-for='(i, index) in caselist' :key='i.id'>案件{{ i.sort }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="btns">
          <a-button icon="search" style="margin:0 10px;" type="primary" ghost
            @click='form.page = 1; getList()'>查询</a-button>
          <a-button v-if="Allshow" icon="search" style="margin:0 10px;" type="primary" ghost
            @click='Preview()'>预览</a-button>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <td width='20'>
              <!--  -->
            </td>
            <td width="40">序号</td>
            <td width='100'>所属案件</td>
            <td width='300'>文件名</td>
            <td width='60'>操作</td>
          </thead>
          <tbody>
            <tr v-for='(i, index) in list' :key="index">
              <td>
                <input type="checkbox" :disabled="i.disabled" v-model='i.checked' @change="outCK(i)" />
              </td>
              <td>{{ (index + 1) + 10 * (form.page - 1) }}</td>
              <td>案件{{ type == 0 ? i.cause.sort : i.cause_sort }} </td>
              <td>
                {{ i.title || i.origin_name }}
                <a href="javascript:void(0);" @click='file = JSON.parse(JSON.stringify(i)); visible = true'
                  v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:files:edit")'>修改</a>
              </td>
              <td style="white-space: nowrap;">
                <a href='javascript:void(0);' class="see" v-if='Filetype(i.url) == 3'>
                  <viewer class="pimg"><img v-for="(decImg, ind) in imgList" :key="ind" :src="decImg.url"
                      style="width: 100%;height: 100%;" :class='{ "fir": decImg.index == index }'> </viewer>浏览
                </a>
                <a href='javascript:void(0);' class="see" @click='see(i)' v-else>浏览</a>
                <span class="line"
                  v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:files:download")'></span>
                <a :href="downFile(i)" target="_blank" :download="i.title || i.origin_name"
                  v-if='$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:files:download")'>下载</a>
                <!-- <a href="javascript:void(0);"  @click='download(i)' :download="i.title || i.origin_name" v-if='$common.AUTH("debtor:files:download")'>下载</a> -->
              </td>
            </tr>
          </tbody>
        </table>
        <a-empty v-if='list.length == 0' style="margin:20px 0;" />
      </div>
      <div class="pages" v-if='total > 10'>
        <a-pagination :total="total" show-less-items show-quick-jumper @change="turnpage" />
      </div>
    </drag-modal>
    <drag-modal :width='dragModalwidth' :visible="visible1" @cancel="() => visible1 = false" :title='notificationtitle'
      :zIndex='10001'>
      <!-- <a :href="downFile(info)" target="_blank" class="down">下载</a> -->
      <div style="display: flex;gap: 10px;justify-content: space-between;width: 100%;">
        <iframe v-for="item in notificationLsit" :key="item.id" :src="item.url" frameborder="0" :width="dragModalwidth"
          height='600'></iframe>
      </div>
    </drag-modal>
  </div>
</template>
<script>
import Upload from "@/components/uploads"
import { mapGetters, mapActions } from 'vuex'
import { debtorFiles, commentsFiles } from "@/server/debtor"
import { rFileName } from "@/server/api"
import FileSee from "@/components/filesee"
import { Filetype } from "@/assets/js/unit"
import { Tacitly } from '@/assets/js/Tacitly'
import t from '../../ruleView/t'
export default {
  name: "File",
  props: {
    type: Number  //0 普通附件 1沟通记录附件
  },
  data() {
    return {
      visible1: false,
      file: {
        title: ''
      },
      visible: false,
      info: {     //查看文件详情
        type: null,
        url: null,
        title: null
      },
      hasCk: true, //是否有复选操作框
      form: {
        limit: 10,
        page: 1,
        title: null,
        cause_id: null,
        debtor_id: this.$route.params.id,
        // show_all: (this.$store.state.user.id || this.$common.AccAUTH($store.state.Debinfo.info.accuser.id,"0-6-6")) ? 1 : 0
      },
      list: [],
      total: null,
      Allshow: false,
      notificationLsit: [],
      notificationtitle: '',
      dragModalwidth: ''
    }
  },
  components: {
    Upload, FileSee
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters([
      'caselist'
    ]),
    imgList() {
      if (this.list) {
        let fileList = JSON.parse(JSON.stringify(this.list))
        fileList.map((ele, index) => {
          ele.index = index
        })
        return fileList.filter(ele => {
          return Filetype(ele.url) == 3
        })
      } else {
        return []
      }
    }
  },
  methods: {
    Preview() {//预览
      this.visible1 = true
      if (this.notificationLsit[1]) {
        this.notificationtitle = this.notificationLsit[0].title + ' / ' + this.notificationLsit[1].title;
        this.dragModalwidth = '80%'
      } else {
        this.dragModalwidth = '740px'
        this.notificationtitle = this.notificationLsit[0].title;
      }

    },
    outCK(currentItem) {   //单选
      let ids = {}
      const checkedCount = this.list.reduce((c, i) => c + (i.checked ? 1 : 0), 0);
      if (checkedCount > 1) {
        // 1. 先将所有项的 disabled 设为 true
        this.list.forEach(item => {
          if (item.id == currentItem.id) {
            ids = currentItem
          }
          item.disabled = true;
        });
        this.notificationLsit.push(ids)
        // 2. 再将已选中的两项的 disabled 设回 false
        this.list.filter(item => item.checked)
          .slice(0, 2)  // 只保留前两个选中的
          .forEach(item => {
            item.disabled = false;
          });
        return;
      }
      // 如果不超过2个，重置所有 disabled 为 false
      this.list = this.list.map(ele => {
        // 如果 Filetype(ele.url) 不等于 2，则设置 disabled 为 true
        if (Filetype(ele.url) == 2) {
          ele.disabled = false;
        } else {
          ele.disabled = true;
        }
        return ele;
      });
      this.notificationLsit = this.list.filter(i => i.checked);
      this.Allshow = this.notificationLsit.length > 0;
    },
    downFile(i) {
      const baseUrl = process.env.NODE_ENV == "development" ? "https://demo.dyuit.cn/xiaoyin/index.php/api/" : Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(i.url)}&filename=${encodeURIComponent(i.title || i.origin_name)}`
    },
    Filetype,
    setName() {
      rFileName({
        upload_id: this.type == 0 ? this.file.upload_id : this.file.id,
        title: this.file.title
      }).then(e => {
        this.$message.success({ content: '修改成功' });
        this.getList()
        this.visible = false
      })
    },
    turnpage(val) {
      this.form.page = val
      this.getList()
    },
    see(i) {
      if (Filetype(i.url) == 4) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + i.url)
      } else {
        this.info = {
          type: Filetype(i.url),
          url: i.url,
          title: i.title || i.origin_name,
        }
        this.$refs.FileSee.visible = true;
      }
    },
    close() {
      this.$store.dispatch('openkey', { key: 'filelist', by: false })
    },
    getList() {
      if (this.type == 0) {
        debtorFiles(this.form).then(e => {

          this.list = e.list.map(item => ({ ...item, checked: false, disabled: false }));
          this.list = this.list.map(ele => {
            // 如果 Filetype(ele.url) 不等于 2，则设置 disabled 为 true
            if (Filetype(ele.url) == 2) {
              ele.disabled = false;
            } else {
              ele.disabled = true;
            }
            return ele;
          });
          this.total = e.count
        })
      }
      else {
        commentsFiles(this.form).then(e => {
          this.list = e.list.map(item => ({ ...item, checked: false, disabled: false }));
          this.list = this.list.map(ele => {
            // 如果 Filetype(ele.url) 不等于 2，则设置 disabled 为 true
            if (Filetype(ele.url) == 2) {
              ele.disabled = false;
            } else {
              ele.disabled = true;
            }
            return ele;
          });
          this.total = e.count
        })
      }
      // console.log('this.list', this.list);
    }
  }
}
</script>
<style lang="less">
.selectbox {
  position: relative;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;

  .lf {
    display: flex;
  }

  .input {
    margin-right: 30px;
  }
}

.see {
  position: relative;
  display: inline-block;

  .pimg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .fir {
    z-index: 999;
  }

  img {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
}

.down {
  position: absolute;
  right: 40px;
  top: 15px;
  width: 80px;
  line-height: 30px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-radius: 4px;
}

.ckall {
  color: #0e2949;
  position: relative;
  cursor: pointer;

  input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  &:hover {
    color: #1890ff;
  }
}
</style>